import {ModelReadUserHaveAsset, ModelReadUserAsset} from './model.js'
//import {RequestinProcess} from '../../helper/request.action.js'

export function PresenterReadUserHaveAsset(params) {
	ModelReadUserHaveAsset(params)
}
export function PresenterReadUserAsset(params) {
	ModelReadUserAsset(params)
}


// WEBPACK FOOTER //
// ./src/App/user/userHaveAsset/presenter.js